(function () {
  const routes = typeof window.routes !== 'undefined' ? window.routes : null;

  function localizeCartErrorMessage(msg) {
    if (!msg || typeof msg !== 'string') return msg;
    if (/already sold out/i.test(msg)) {
      return window.variantStrings?.soldOut || msg;
    }
    return msg;
  }

  function toggleFormError(wrapper, msg) {
    if (!wrapper) return;
    const inner = wrapper.querySelector('.product-form__error-message');
    if (!inner) return;
    if (msg) {
      inner.textContent = localizeCartErrorMessage(msg);
      wrapper.removeAttribute('hidden');
    } else {
      inner.textContent = '';
      wrapper.setAttribute('hidden', 'hidden');
    }
  }

  function resolveVariantIdFromProductForm(productFormCard) {
    const productInfo = productFormCard.closest('product-info');
    if (productInfo) {
      try {
        const raw = productInfo.querySelector('variant-selects [data-selected-variant]')?.textContent;
        if (raw?.trim()) {
          const variant = JSON.parse(raw.trim());
          if (variant?.id) return String(variant.id);
        }
      } catch (e) {
        console.warn('[ark-product-buy-now] resolveVariantId', e);
      }
    }

    const form = productFormCard.querySelector('form[data-type="add-to-cart-form"]');
    const idInput = variantInput(form);
    const fromInput = idInput?.value ? String(idInput.value).trim() : '';
    if (fromInput) return fromInput;

    const checked = productInfo?.querySelector('variant-selects input[data-variant-id]:checked');
    if (checked?.dataset?.variantId) {
      return String(checked.dataset.variantId);
    }

    return '';
  }

  function getQty(form) {
    const qty = form.querySelector('input[name="quantity"]');
    if (!qty || qty.disabled) return 1;
    const n = parseInt(qty.value, 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  function variantInput(form) {
    return (
      form.querySelector('input.product-variant-id[name="id"]') || form.querySelector('input[name="id"]')
    );
  }

  function syncInstantWithAddToCart(sectionId) {
    const submit = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const instant = document.getElementById(`ArkBuyNowButton-${sectionId}`);
    if (!instant) return;

    const disable =
      submit &&
      (submit.hasAttribute('disabled') || submit.getAttribute('aria-disabled') === 'true');

    if (disable) {
      instant.setAttribute('disabled', 'disabled');
    } else {
      instant.removeAttribute('disabled');
    }
  }

  function syncAllInstantButtons() {
    document.querySelectorAll('product-form[data-section-id]').forEach((pf) => {
      const sid = pf.dataset.sectionId;
      if (sid) syncInstantWithAddToCart(sid);
    });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ark-buy-now]');
    if (!btn || btn.disabled || !routes?.cart_add_url) return;

    const productFormCard = btn.closest('product-form');
    if (!productFormCard) return;

    const form = productFormCard.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    const idInput = variantInput(form);
    const variantId = resolveVariantIdFromProductForm(productFormCard);
    if (!variantId) return;
    if (idInput) {
      idInput.value = variantId;
      idInput.removeAttribute('disabled');
    }

    e.preventDefault();
    toggleFormError(productFormCard.querySelector('.product-form__error-message-wrapper'), false);

    const errWrap = productFormCard.querySelector('.product-form__error-message-wrapper');

    const addUrl =
      typeof getCartAddJsUrl === 'function'
        ? getCartAddJsUrl()
        : routes.cart_add_url.endsWith('.js')
          ? routes.cart_add_url
          : `${routes.cart_add_url.replace(/\/?$/, '')}.js`;

    const innerEl = btn.querySelector('.product-form__instant-inner');
    const spin = btn.querySelector('.loading__spinner');

    btn.setAttribute('disabled', 'disabled');
    if (innerEl) innerEl.style.opacity = '0';
    if (spin) spin.classList.remove('hidden');

    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: getQty(form) }],
      }),
    })
      .then(async (response) => {
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          const msg =
            data.description ||
            data.message ||
            (typeof data.errors === 'object' ? Object.values(data.errors).flat().join(' ') : null) ||
            window.cartStrings?.error ||
            '';
          toggleFormError(errWrap, msg);
          return;
        }
        if (data.status && Number(data.status) >= 400) {
          toggleFormError(
            errWrap,
            data.description || data.message || window.cartStrings?.error || ''
          );
          return;
        }
        window.location.assign('/checkout');
      })
      .catch(() => {
        toggleFormError(errWrap, window.cartStrings?.error || '');
      })
      .finally(() => {
        btn.removeAttribute('disabled');
        if (innerEl) innerEl.style.opacity = '';
        if (spin) spin.classList.add('hidden');
        const sid = productFormCard.dataset.sectionId;
        if (sid) syncInstantWithAddToCart(sid);
      });
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const sid = event?.data?.sectionId;
      if (sid) syncInstantWithAddToCart(String(sid));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllInstantButtons);
  } else {
    syncAllInstantButtons();
  }
})();
